export enum ParticipateModule {
  CLASSIC = 'classic',
  FAST = 'fast',
  HILO = 'hilo',
  DOUBLE = 'double',
  X50 = 'x50',
  BACCARAT = 'baccarat',
}
